export const allowedOrigins = [
  'https://mode-web.webflow.io',
  'https://www.mode.network',
  'https://synth-923480.webflow.io',
  'https://www.synthdata.co',
];

export enum SupportedInsightsAsset {
  BTC = 'BTC',
  ETH = 'ETH',
}
